import { ChangeDetectorRef, OnDestroy, Component, EventEmitter, Host, Input, OnInit, Optional, Output, SimpleChanges, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import * as $ from 'jquery';
import { NgOtpInputComponent } from 'ng-otp-input';
import { SmsFlowService } from 'src/app/pages/widget/types/sms/sms-flow-service.service';
import { SmsComponent } from 'src/app/pages/widget/types/sms/sms.component';
import { Solicitud } from 'src/entity/solicitud';
import { PinUtilsService } from 'src/app/pages/widget/types/pin/pin-utils.service';
import { environment } from 'src/environments/environment';
import { CustomizationStoreService } from 'src/services/customization.store.service';
import { SolicitudesService } from 'src/services/solicitudes.service';
import { UtilsService } from 'src/services/utils.service';

@Component({
  selector: 'belender-shared-otp-step',
  templateUrl: './otp-step.component.html',
  styleUrls: ['./otp-step.component.scss']
})
export class OtpStepComponent implements OnInit, OnDestroy {
  @Input() data;
  @Input() texts;
  @Input() lastThreeNumbersPhone;
  @Input() otpType: 'otpSS' | 'otpAEAT' | 'otpIRS' | 'otpSSD' | 'otpBDE' | 'otpCC';
  @Input() minLength: number = 3;
  @Input() flowType;
  @Input() logoCustom = '';
  @Input() labels;
  @Input() requestID;
  @Input() testMode;
  @Input() solicitud;
  @Output('nextStep') next = new EventEmitter(null);
  @Output('errorPhone') errPhone = new EventEmitter(null);
  @Output('resendOTP') resendO = new EventEmitter(null);
  packId;
  userId;
  form: UntypedFormGroup;
  secsCount = 60;
  interv;
  secondTry = false;
  secsRemaining;
  timerIsRunning: boolean = false;
  env = environment.env;
  @ViewChild(NgOtpInputComponent, { static: false }) ngOtpInput: NgOtpInputComponent;

  subsPhone;
  limitSecsCount = 60;

  constructor(
    @Optional() @Host() private smsComponent: SmsComponent, // Acceso a métodos del padre
    private fb: UntypedFormBuilder,
    public utils: UtilsService,
    private smsFlowService: SmsFlowService,
    private solicitudesService: SolicitudesService,
    private cd: ChangeDetectorRef,
    public customizationStoreService: CustomizationStoreService,
    public pinUtils: PinUtilsService
  ) { }


  ngOnInit() {
    this.packId = this.customizationStoreService.PACK_ID;
    this.userId = this.customizationStoreService.USER_ID;
    this.resolveLabels();
    this.form = this.fb.group({
      code1: [null, [Validators.required, Validators.maxLength(6), Validators.minLength(this.minLength)]],
    });

    this.subsPhone = this.pinUtils.lastThreeNumbersPhone$.subscribe(l3n => {
      this.lastThreeNumbersPhone = l3n;
    })

    this.subsPhone = this.pinUtils.lastThreeNumbersPhone$.subscribe(l3n => {
      this.lastThreeNumbersPhone = l3n;
    })

    if (this.flowType == 'SMS' && (this.solicitud && this.solicitud.person_phone)) {
      this.setPhone(this.solicitud.person_phone);
    }
  }

  ngOnDestroy(): void {
    this.subsPhone && this.subsPhone.unsubscribe();
  }

  public resetOtpNumber() {
    this.form.get('code1').setValue('');
    this.ngOtpInput.setValue('');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.otpType && !changes.otpType.previousValue) {
      changes.otpType?.currentValue == 'otpAEAT' || changes.otpType?.currentValue == 'otpIRS' ? this.limitSecsCount = 300 : this.limitSecsCount = 60;

      this.initSecsInterval();
    }
  }

  setPhone(phone) {
    let r = 'XXX';
    if(phone) {
      r = ('' + phone).slice(-3);
    }
    this.lastThreeNumbersPhone = r;
  }

  private resolveLabels(): void {
    if (!this.labels) {
      this.labels = this.pinUtils.labels;
    }
  }

  initSecsInterval() {
    if (!this.timerIsRunning) {
      this.secsCount = +this.limitSecsCount;
      this.interv = setInterval(() => {
        this.timerIsRunning = true;
        this.secsCount = this.secsCount - 1;
        this.secsRemaining = this.getRemaining();
        if (this.secsCount <= 0) {
          this.finishSecsInterval();
        }
      }, 1000);
    }
  }

  getRemaining() {
    let m = Math.floor(this.secsCount / 60);
    let s = this.secsCount % 60;
    return this.addZero(m) + ':' + this.addZero(s);
  }

  addZero(n) {
    if(n >= 10) {
      return n;
    } else {
      return '0' + n;
    }
  }

  finishSecsInterval() {
    this.timerIsRunning = false;
    this.interv && clearInterval(this.interv);
  }

  getCode() {
    let c1 = this.form.get('code1').value;

    return c1 ;
  }

  async capturePasteEvent(e) {
    this.form.get('code1').setValue(e);
  }

  setInputEvent(e) {
    if(e.target.value != '') {
      $(e.target).next().focus();
    } else {
      if(e.code == 'Backspace') {
        $(e.target).prev().focus();
      }
    }
  }

  nextStep() {
    let obj = {
      code: this.getCode()
    }

    if (this.flowType === 'SMS') {
      this.requestSmsOTP(obj);
    } else {
      this.next.emit(obj);
    }
  }

  resendOTP() {
    this.secondTry = true;
    this.initSecsInterval();

    if (this.flowType === 'SMS') {
      this.resendSmsOTP(true);
    } else {
      this.resendO.emit(true);
    }
  }

  requestSmsOTP(e) {
    this.smsFlowService.setLoading(this.labels.loadings.sendingData);
    this.smsComponent.showAlert(null)
    if (this.testMode) {
      setTimeout(() => {
        this.smsFlowService.setRequest(new Solicitud());
        this.smsComponent.setRequestStatus("all_documents_downloaded");
        this.smsComponent.setStatus();
        this.smsFlowService.setLoading(false);
      }, 2000);
    } else {
      let obj = {
        request_id: this.requestID,
        user_id: this.userId,
        code: e.code,
      };
      this.solicitudesService
        .sendOTP(obj)
        .then((d: any) => {
          if (d.status && d.status == "error") {
            if (
              d.message &&
              d.message ==
                "Invalid request status: waiting_login_seguridad_social"
            ) {
              this.smsComponent.showAlert(this.labels.warnings.error, this.labels.warnings.unknownError);
            } else if (d.message) {
              if(d.message.code) {
                this.smsComponent.showAlert(this.labels.warnings.error, this.labels.warnings.wrongOtp);
              } else if(d.message.request_id) {
                this.smsComponent.showAlert(this.labels.warnings.error, this.labels.warnings.noRequests);
              } else {
                this.smsComponent.showAlert(this.labels.warnings.error, this.labels.warnings.unknownError);
              }
            } else {
              this.smsComponent.showAlert(this.labels.warnings.error, this.labels.warnings.unknownError);
            }
            this.smsFlowService.setLoading(false);
          } else if (d && d.status == "success") {

            this.smsComponent.handleRequestStatus(d.data || d);
            this.cd.markForCheck();
          }
        })
        .catch((e) => {
          this.smsComponent.showAlert(this.labels.warnings.error, e?.error || e?.message || e || this.labels.warnings.unknownError);
          this.smsFlowService.setLoading(false);
        });
    }

    this.resetOtpNumber();
  }

  resendSmsOTP(e) {
    let rID =
      this.smsFlowService.REQUEST && this.smsFlowService.REQUEST.request_id
        ? this.smsFlowService.REQUEST.request_id
        : this.requestID;
    let o = {
      request_id: rID || e,
      user_id: this.userId,
    };
    this.smsComponent.showAlert(null)
    this.smsFlowService.setLoading(this.labels.loadings.resendingOtp);
    this.smsFlowService.setSubscriptionOfRequest();
    this.solicitudesService
      .resendOTP(o)
      .then((e: any) => {
        if (e && e.data) {
          this.smsFlowService.setRequest(e.data);
          this.smsComponent.setStatus();
        }
        this.smsFlowService.setLoading(false);
      })
      .catch((e) => {
        console.error(e);
        this.smsComponent.showAlert(this.labels.warnings.error, e?.error || e?.message || e || this.labels.warnings.unknownError);
        this.smsFlowService.setLoading(false);
      });

    this.resetOtpNumber();
  }
}
